export default "__VITE_ASSET__CpJ7AlFp__"